import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Input from '../components/form/input';
import { UserAuth } from '../context/AuthContext';
import Swal from 'sweetalert2';
import Loading from '../components/Loading';
import { useState } from 'react';
import { useTranslations } from '../translations';

const ForgotPassword = () => {
	
  const { t } = useTranslations()
	const [required, setRequired] = useState("");
	const { loading, error, passwordRecovery, user } = UserAuth();
	const { control, handleSubmit } = useForm({
		defaultValues: {
			email: ''
		}
	});
	const Toast = Swal.mixin({
		toast: true,
		position: 'top-end',
		showConfirmButton: false,
		timer: 5000,
		timerProgressBar: true,
		didOpen: (toast) => {
		  toast.addEventListener('mouseenter', Swal.stopTimer)
		  toast.addEventListener('mouseleave', Swal.resumeTimer)
		}
	  })
	
	const navigate = useNavigate();

	const onSubmit = async (data,e) => {
		e.preventDefault();
		if(!data.email){
			setRequired(t("emailRequired"));
			return;
		}
		await passwordRecovery(data.email);
		if(!error)
			Toast.fire({
				icon: 'success',
				title: t("emailSentSuccess"),
				text: t("checkInbox")
			}).then(() => {
				navigate("/login");
			});
	};

	if (error){
		 Toast.fire({
			icon: 'error',
			title: error,
		  }).then(() => {
			return;
		  });
	}

	if(loading)
		return <Loading/>
	
	return (
		<div className="login-content">
			<form onSubmit={handleSubmit(onSubmit)}>
				<Link to={"/"}><img src="/assets/img/landing-images/MiABC-33.png" alt="MiABC Logo" className="auth-logo" /></Link>
				<h3 className="title">{t("restartPassword")}</h3>
				<div id="input-div-forgot" className="input-div one">
					<div className="i">
						<i className="fas fa-user"></i>
					</div>
					<Input
						// label=""
						control={control}
						name="email"
						inputId="input-div-forgot"
						type="email"
						id="email"
						label={t("email")}
					/>
				</div>
				<div className='text-danger mt-0'>{required ? required : ''}</div>
				<input type="submit" className="btn" value={t("sendInstructions")} />
				<Link to="/login">
					{t("alreadyHaveAccount")} <strong>{t("signIn")}</strong>
				</Link>
				<p className="text-link-1 mt-2">{t("privacyText")} <Link to="/privacy" target="_blank">{t("privacyPolicy")}</Link></p>
			</form>
		</div>
	);
};

export default ForgotPassword;
